<template>
  <NuxtLayout name="standard">
    <div v-if="howPlatformWorksPageData">
      <SHeroAngled v-bind="hero" />

      <TContainer class="pb-16">
        <TGrid>
          <div class="lg:col-start-3 col-span-12 lg:col-span-8">
            <SMarkdown v-bind="markdown" />
          </div>
        </TGrid>
      </TContainer>
      <SSpacer />
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
// Types
import { type schemaType as howPlatformWorksPageSchemaType } from '~/modules/api/strapi/how-platform-works-page/schema'

// Composables
import { useHeadInfoComposable } from '~/modules/head/composables/useHeadInfoComposable'

// Apis
import getHowPlatformWorksPageData from '~/modules/api/strapi/how-platform-works-page'

// Transformers
import { useToSHeroAngled } from '~/composables/transformers/useToSHeroAngled'
import { useToSMarkdown } from '~/composables/transformers/useToSMarkdown'

// Components Props
import type { propsInterface as sHeroCardProps } from '~/modules/design-system/sections/s-hero-angled.vue'
import type { propsInterface as smarkdownProps } from '~/modules/design-system/sections/s-markdown.vue'

const { setHeadInfo } = useHeadInfoComposable()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const dataApiDetail = await getHowPlatformWorksPageData()

let howPlatformWorksPageData: howPlatformWorksPageSchemaType
let hero: sHeroCardProps
let markdown: smarkdownProps

if (dataApiDetail.success && dataApiDetail.success.data) {
  howPlatformWorksPageData = dataApiDetail.success.data

  if (howPlatformWorksPageData) {
    setHeadInfo({
      title: howPlatformWorksPageData.attributes.head.title,
      description: howPlatformWorksPageData?.attributes.head.description,
      images: [
        {
          url: howPlatformWorksPageData.attributes.head.image.data.attributes
            .url,
          alt: howPlatformWorksPageData.attributes.head.title,
        },
      ],
      robotsVisible: true,
    })

    hero = useToSHeroAngled().fromStrapiHowPlatformWorksPage(
      howPlatformWorksPageData,
    )
    markdown = {
      text: useToSMarkdown().fromStrapiHowPlatformWorksPage(
        howPlatformWorksPageData,
      ),
      responsive: true,
      clear: true,
    }
  }
} else if (dataApiDetail.error) {
  showErrorPage(dataApiDetail.error as ApiResponseError)
}
</script>
